<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :model="form"
               ref="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="profession"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         @change="getType"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="name"
                          label="问卷名称">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item prop="type"
                          label="问卷类型">
              <el-select clearable
                         v-model="form.type"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in queslists"
                           :key="item.type"
                           :label="item.type_name"
                           :value="item.type">{{ item.type_name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="actFlag"
                          label="问卷状态">
              <el-select clearable
                         v-model="form.actFlag"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option label="开启"
                           value="T"></el-option>
                <el-option label="关闭"
                           value="F"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="quesBtn">确定</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <!-- <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
      </action-line> -->
      <el-button size="medium" @click="clearSearch">重置</el-button>
      <el-button size="medium" type="primary" @click="handleImport">导入</el-button>
    </el-card>
    <!-- 问卷list -->
    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData"
              row-key="id"
              style="width: 100%">
        <el-table-column prop="name" label="问卷名称" :resizable="false" align="center"></el-table-column>
        <el-table-column prop="type" label="问卷类型" :resizable="false" align="center"></el-table-column>
        <el-table-column prop="profession" label="行业" :resizable="false" align="center"></el-table-column>
        <el-table-column prop="business" label="商家" :resizable="false" align="center"></el-table-column>
        <el-table-column prop="store" label="店铺" :resizable="false" align="center"></el-table-column>
        <el-table-column label="操作" :resizable="false" align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="详情" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-info" size="mini" @click="showDtiDilog(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
    </el-table>
    <!-- 模板 -->
    <el-dialog title="模板字段"
               :visible.sync="editdialogFileFormVisible"
               @close="editDilogClosed"
                custom-class="importDialogq"
               :close-on-click-modal="false">
      <el-form :model="editform"
               ref="editformRef"
               :rules="rules"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="6">
            <el-form-item label-width prop="name" label="模板名称">
              <el-input v-model="editform.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- el-table -->
        <el-table v-loading="loading"
                  border
                  :data="tableEditData"
                  row-key="id"
                  style="width: 100%">
            <el-table-column :prop="dropList[index].prop"
                  align="center"
                  header-align="center"
                  v-for="(item, index) in colList"
                  :key="'col_'+index"
                  width="300"
                  :fixed="index == 0 ? true : false"
                  :label="item.label">
                  <template slot-scope="scope">
                    <div class="head" v-if="index == 0">{{scope.row[dropList[index].prop]}}</div>
                    <div class="headcol" v-else>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'text'">
                        <el-input v-model="scope.row[dropList[index].prop].name" style="width: 50%;"></el-input>
                      </div>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'checkbox'">
                        <el-checkbox v-model="scope.row[dropList[index].prop].name" :true-label="'Y'" :false-label="'N'"></el-checkbox>
                      </div>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'select'">
                        <el-select clearable
                              v-model="scope.row[dropList[index].prop].name"
                              placeholder="请选择" style="width: 50%">
                          <el-option label="日期" value="date"></el-option>
                          <el-option label="数字" value="number"></el-option>
                          <el-option label="文字" value="text"></el-option>
                        </el-select>
                      </div>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'date'">
                        <el-date-picker v-model="scope.row[dropList[index].prop].value"
                                      type="date"
                                      placeholder="开始日期"
                                      value-format="yyyy-MM-dd"
                                      style="width: 50%;"></el-date-picker>
                      </div>
                    </div>
                  </template>
                  </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="cancelFileShop">取 消</el-button>
        <el-button type="primary"
                   @click="saveFileShop">保 存</el-button>
      </div>
    </el-dialog>
    <el-card v-if="total.length>0">
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <import-dialog @submit="handleFile"
                   @sucmit="handSucFile"
                   ref="refImportDialog" />
    <set-dialog ref="refDtiDialog" :queryInfo="form" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import SetDialog from './dialog'
import ImportDialog from './importDialog'
export default {
  mixins: [ActionLine, SearchMixin],
  components: { SetDialog, ImportDialog },
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
      queslists: [],
      rules: {
        profession: [{ required: true, message: '必选项', trigger: 'blur' }],
        business: [{ required: true, message: '必选项', trigger: 'blur' }],
        store: [{ required: true, message: '必选项', trigger: 'blur' }],
        type: [{ required: true, message: '必选项', trigger: 'blur' }],
        name: [{ required: true, message: '模板名称', trigger: 'blur' }]
      },
      editdialogFileFormVisible: false,
      colList:[],
      dropList:[],
      tableEditData: [],
      editform: {
        profession: '',
        business: '',
        store: '',
        id: '',
        name: '',
        oid: ''
      },
    }
  },
  created() {
  },
  methods: {
    // 问卷列表
    async getSurList() {
      this.loading = true
      let query = {
        url: 'surList',
        title: '列表',
        method: 'post'
      }
      this.queryPrdlists.query = this.form
      let { data, err } = await this.axiosApi(
        query,
        this.queryPrdlists
      )
      this.tableData = data.data.data.data
      this.loading = false
    },
    // 问卷编辑
    async getTablData() {
      this.loading = true;
      let query = {
        url: 'surTitleDetail',
        title: '列表',
        method: 'post'
      }
      let parm = {
        query: {
          id: this.editform.id
        }
      }
      let { data, err } = await this.axiosApi(
        query,
        parm
      );
      this.loading = false
      this.colList = []
      this.dropList = []
      data.data.data.title.forEach(item => {
        if(item.name && item.label){
          this.colList.push({
            label: item.name,
            prop: item.label
          })
        }
      })
      this.dropList = this.colList
      this.tableEditData = data.data.data.list
      this.editform.name = data.data.data.name
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err);
    },
    // 问卷类型
    async getType() {
      this.loading = true
      let query = {
        url: 'getType',
        title: '问卷类型',
        method: 'post'
      }
      let parm = {
        query: this.form
      }
      let { data, err } = await this.axiosApi(
        query,
        parm
      )
      this.queslists = data.data.data
      this.loading = false
    },
    // 详情
    async showDtiDilog(row) {
      this.$refs.refDtiDialog.show(row)
    },
    // 查询
    async quesBtn() {
      this.$refs.form.validate((valid) => {
        if(!valid) return

        if (!this.form.store) {
          this.$message.error('请先选择店铺')
          return
        }
        this.getSurList()
      })
    },
    // 保存oid
    getquesOid() {
      this.$refs.refImportDialog.getmodifState(this.editform.oid)
    },
    // 取消保存编辑
    cancelFileShop() {
      this.$refs.refImportDialog.getcancelBySurvey({oid: this.editform.oid, sid: this.editform.sid, status: this.editform.status})
      this.editdialogFileFormVisible = false
    },
    // 保存编辑字段
    saveFileShop() {
      this.$refs.editformRef.validate((valid) => {
        if(!valid) return
        let parm = {
          query: this.tableEditData
        }
        Object.assign(parm, this.editform)
        if(!this.duplicateSel(parm)){
          this.$confirm('您的去重项没有选择，是否确定保存？', '提示',{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'})
            .then(() => {
              this.smtFileShop(parm)
            }).catch(() => {
              // this.$message({type: 'info', message: '已取消'})
            })
        }else{
          this.smtFileShop(parm)
        }
      })
    },
    smtFileShop(parm) {
      this.$http
        .post('surStore', parm)
        .then((response) => {
          const res = response.data

          this.$message.success('编辑成功')
          this.editdialogFileFormVisible = false
          this.getquesOid()
          this.getSurList()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    handleFile(row) {
      this.editform.profession = row.profession
      this.editform.business = row.business
      this.editform.store = row.store
      this.editform.id = row.sid
      this.editform.sid = row.sid
      this.editform.oid = row.oid
      this.editform.status = row.status
      this.getTablData()
      this.editdialogFileFormVisible = true
    },
    // 去重项
    duplicateSel(e) {
      let s = false
      e.query.forEach((item, index) => {
        if(item.表头 == '去重项'){
          let optlist = Object.values(item)
          optlist.forEach((itm, idx) => {
            if(typeof(itm) == 'object'){
              if(itm.name == 'Y'){
                s = true
              }
            }
          })
        }
      })
      return s
    },
    handSucFile(row) {
    },
    editDilogClosed() {},
    clearSearch () {
      this.form = {
        business: '',
        store: ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialogq {
    width: 80%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/base/memberquesrgath/index.vue